import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  Tooltip,
  type TooltipProps,
  Typography,
  tooltipClasses,
  useTheme
} from '@mui/material';
import { type FC, Fragment, type ReactElement } from 'react';
import type { ProductDispenseTempData } from '../../models';

interface AvaniTempProductListProps {
  products: ProductDispenseTempData[];
  units?: string;
  dense?: boolean;
  listTypeIcon?: ReactElement;
  truncateValue?: boolean;
  date?: 'prop' | 'val';
  link?: boolean;
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.avani.lightTurc,
    maxWidth: 320,
    borderRadius: '16px',
    border: `1px solid ${theme.colors.avani.magenta}`
  }
}));

export const AvaniTempProductList: FC<AvaniTempProductListProps> = ({
  products,
  units,
  dense,
  listTypeIcon,
  truncateValue,
  date,
  link
}) => {
  const theme = useTheme();
  const productNameSx: any = truncateValue
    ? { paddingTop: '3px', paddingLeft: '4px', float: 'left' }
    : {
        display: 'inline-block',
        paddingTop: '3px',
        paddingLeft: '4px',
        flexGrow: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      };

  return (
    <List
      disablePadding
      sx={{
        display: 'block',
        minWidth: '178px'
      }}
    >
      {products.map((product, i) => {
        return (
          <ListItem
            disablePadding
            key={i}
            sx={{
              display: 'block',
              borderBottom: `1px dashed ${theme.colors.avani.teal}`,
              paddingBottom: dense ? 1 : 1.5,
              pt: i > 0 ? (dense ? 1 : 1.5) : 0
            }}
          >
            <Typography
              variant={'body2'}
              component={'div'}
              fontWeight={'bold'}
              fontSize={dense ? 14 : 16}
              color={'primary'}
              sx={{
                display: 'flex',
                cursor: link ? 'pointer' : 'default'
              }}
            >
              {listTypeIcon && listTypeIcon}
              <HtmlTooltip
                title={
                  <Fragment>
                    <List>
                      <ListItem
                        sx={{
                          display: 'flex',
                          [`.MuiListItemIcon-root`]: {
                            paddingRight: 3
                          },
                          [`.MuiListItemText-root`]: {
                            textAlign: 'right'
                          }
                        }}
                      >
                        <ListItemText
                          sx={{
                            color: theme.colors.avani.turc
                          }}
                        >
                          {product.productName}
                        </ListItemText>
                        <ListItemIcon>{units}</ListItemIcon>
                      </ListItem>
                    </List>
                  </Fragment>
                }
              >
                <span style={productNameSx}>
                  {product.productName} <span style={{ float: 'right' }}>{units ? ` ${units}` : ''}</span>
                </span>
              </HtmlTooltip>

              {/* {product.value && <span style={productValueSx}>{product.value + (units ? ' ' + units : '')}</span>} */}
            </Typography>
          </ListItem>
        );
      })}
    </List>
  );
};
